import { GENERAL_DISEASE, GENERAL_DISEASE_SUB_TYPE } from 'utils/constants/disease';
import { INFO_ATTRIBUTES } from 'utils/constants/user';
import { DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';
// eslint-disable-next-line import/no-cycle
import { getQstack, getQuestionnaireQuestions, isIntegratedDisease } from 'modules/questionnaire/helpers';
import { QUESTION_ID } from 'modules/questionnaire/questionIds';
import { deduplicate } from 'functions/deduplicate';

const { [GENERAL_DISEASE]: GENERAL_DISEASE_SUB_TYPE_QUESTION_ID } = DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE;

export const getGeneralDiseaseSubType = (conditionProfile) => {
  let subTypeQuestionValue = conditionProfile[GENERAL_DISEASE_SUB_TYPE_QUESTION_ID];

  if (!subTypeQuestionValue || (Array.isArray(subTypeQuestionValue) && !subTypeQuestionValue.length)) {
    return null;
  }

  if (Array.isArray(subTypeQuestionValue)) {
    [subTypeQuestionValue] = subTypeQuestionValue;
  }

  return Object.values(GENERAL_DISEASE_SUB_TYPE).includes(subTypeQuestionValue)
    ? subTypeQuestionValue
    : null;
};

// disease can be
// - any disease
// - general disease
// - one of GENERAL_DISEASE_SUB_TYPE
export const getConditionProfileByDisease = async (disease) => {
  let adjustedDisease = disease;

  let generalDiseaseSubType;
  if (Object.values(GENERAL_DISEASE_SUB_TYPE).includes(disease)) {
    adjustedDisease = GENERAL_DISEASE;
    generalDiseaseSubType = disease;
  }
  const allQuestions = await getQuestionnaireQuestions(adjustedDisease);

  const qstack = getQstack({ questions: allQuestions, conditionProfile: {} });

  const conditionProfile = Object.fromEntries(allQuestions.map(({ id }) => [id, null]));

  Object.assign(conditionProfile, {
    [QUESTION_ID.treatments.questionId]: [],
    [QUESTION_ID.procedures.questionId]: [],
    qstack,
  });

  if (isIntegratedDisease(adjustedDisease)) {
    Object.assign(conditionProfile, {
      [QUESTION_ID.tnm]: [],
    });

    delete conditionProfile.preferred_location;
  }

  if (adjustedDisease === GENERAL_DISEASE && generalDiseaseSubType) {
    conditionProfile[GENERAL_DISEASE_SUB_TYPE_QUESTION_ID] = generalDiseaseSubType;
    // qstack already has corresponding field
  }

  // Removes personal / info attributes from the condition_profile
  INFO_ATTRIBUTES.forEach((a) => delete conditionProfile[a]);

  return conditionProfile;
};

// indication can be
// - any disease
// - general disease
// - one of GENERAL_DISEASE_SUB_TYPE
export const getInitialConditionProfile = async (disease, data) => {
  const conditionProfile = await getConditionProfileByDisease(disease);

  if (!data) {
    return conditionProfile;
  }

  for (const attr in data) {
    if (attr !== 'qstack') {
      conditionProfile[attr] = data[attr];
    }
  }

  if (data.qstack) {
    conditionProfile.qstack = deduplicate([...conditionProfile.qstack, ...data.qstack]);
  }

  return conditionProfile;
};

export const filterConditionProfileForNoneBiomarkers = (data) => {
  if (!Array.isArray(data.biomarkers)) {
    return data;
  }
  return {
    ...data,
    // biomarkers: [] not biomarkers: null
    biomarkers: data.biomarkers.filter((i) => i !== 'none'),
  };
};
